export const STYLE_CONSTANTS = {
    Z_INDEX: 1 // Base value for stacking context, must be shared between app and baseUI provider
};
